import { apiSlice, createPaginatedListEndpoint, createBodyMutation } from './baseApi';

export const serviceTypeApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getServiceTypes: builder.query({
      query: (companyId) => ({
        url: '/service-type/get-all-service-types',
        method: 'POST',
        body: { company_id: companyId },
      }),
      transformResponse: (response) => {
        const types = response?.serviceTypes || [];
        return types.map((type) => ({
          ...type,
          value: type._id,
        }));
      },
      providesTags: ['ServiceTypes'],
    }),
    getServiceTypesList: builder.query(
      createPaginatedListEndpoint({
        url: '/service-type/get-all-service-types',
        responseKey: 'serviceTypes',
        tag: 'ServiceTypes',
      })
    ),
    addServiceType: builder.mutation(
      createBodyMutation({ url: '/service-type/add-service-type', invalidatesTags: ['ServiceTypes'] })
    ),
    editServiceType: builder.mutation(
      createBodyMutation({ url: '/service-type/edit-service-type', invalidatesTags: ['ServiceTypes'] })
    ),
    deleteServiceType: builder.mutation(
      createBodyMutation({ url: '/service-type/delete-service-type', invalidatesTags: ['ServiceTypes'] })
    ),
  }),
});
